'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var log = require('debug')('mss:select');

var errCode = require('err-code');

var multistream = require('./multistream');

var handshake = require('it-handshake');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, protocols, protocolId) {
    var _handshake, reader, writer, rest, shakeStream, protocol, response, _iterator, _step, _protocol, _response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            protocols = Array.isArray(protocols) ? _toConsumableArray(protocols) : [protocols];
            _handshake = handshake(stream), reader = _handshake.reader, writer = _handshake.writer, rest = _handshake.rest, shakeStream = _handshake.stream;
            protocol = protocols.shift();

            if (protocolId) {
              log('select: write ["%s", "%s"]', protocolId, protocol);
              multistream.writeAll(writer, [protocolId, protocol]);
            } else {
              log('select: write "%s"', protocol);
              multistream.write(writer, protocol);
            }

            _context.next = 6;
            return multistream.read(reader);

          case 6:
            response = _context.sent.toString();
            log('select: read "%s"', response); // Read the protocol response if we got the protocolId in return

            if (!(response === protocolId)) {
              _context.next = 13;
              break;
            }

            _context.next = 11;
            return multistream.read(reader);

          case 11:
            response = _context.sent.toString();
            log('select: read "%s"', response);

          case 13:
            if (!(response === protocol)) {
              _context.next = 16;
              break;
            }

            rest();
            return _context.abrupt("return", {
              stream: shakeStream,
              protocol: protocol
            });

          case 16:
            // We haven't gotten a valid ack, try the other protocols
            _iterator = _createForOfIteratorHelper(protocols);
            _context.prev = 17;

            _iterator.s();

          case 19:
            if ((_step = _iterator.n()).done) {
              _context.next = 32;
              break;
            }

            _protocol = _step.value;
            log('select: write "%s"', _protocol);
            multistream.write(writer, _protocol);
            _context.next = 25;
            return multistream.read(reader);

          case 25:
            _response = _context.sent.toString();
            log('select: read "%s" for "%s"', _response, _protocol);

            if (!(_response === _protocol)) {
              _context.next = 30;
              break;
            }

            rest(); // End our writer so others can start writing to stream

            return _context.abrupt("return", {
              stream: shakeStream,
              protocol: _protocol
            });

          case 30:
            _context.next = 19;
            break;

          case 32:
            _context.next = 37;
            break;

          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](17);

            _iterator.e(_context.t0);

          case 37:
            _context.prev = 37;

            _iterator.f();

            return _context.finish(37);

          case 40:
            rest();
            throw errCode(new Error('protocol selection failed'), 'ERR_UNSUPPORTED_PROTOCOL');

          case 42:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 34, 37, 40]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();